import { render, staticRenderFns } from "./roleUser.vue?vue&type=template&id=3aeb361d"
import script from "./roleUser.vue?vue&type=script&lang=js"
export * from "./roleUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports